<template>
  <div
    class="bg-white rounded-[12px] p-5 shadow-sm border border-[#E5E5E5]"
    data-testid="impact-dimension-anomaly"
  >
    <div class="flex flex-wrap items-center justify-between gap-2 mb-3">
      <p class="text-[13px] font-semibold text-[var(--color-dark)] m-0">
        {{ $t('UserProjects.impactAnalysis.dimensions.title') }}
      </p>
      <span class="text-[11px] text-[var(--color-disabled)]">
        n={{ entriesN }} · {{ periodLabel }}
      </span>
    </div>

    <p class="text-[11px] text-[var(--color-disabled)] mb-3 m-0">
      {{ $t('UserProjects.impactAnalysis.dimensions.subtitle') }}
    </p>

    <div
      v-if="showEmpty"
      class="text-[13px] text-[var(--color-disabled)] py-2"
      data-testid="impact-dimension-anomaly-empty"
    >
      {{ $t('UserProjects.impactAnalysis.dimensions.empty') }}
    </div>

    <div v-else class="space-y-2.5" data-testid="impact-dimension-anomaly-list">
      <div
        v-for="item in items"
        :key="item.key"
        class="flex items-center gap-3"
        :data-testid="`impact-dimension-anomaly-row-${item.key}`"
        :data-anomaly="item.isAnomaly ? 'true' : 'false'"
      >
        <span
          class="text-[12px] text-[var(--color-dark)] w-36 shrink-0 truncate"
          :class="{ 'font-semibold': item.isAnomaly }"
        >
          {{ dimensionLabel(item.key) }}
        </span>
        <div class="flex-1 h-2.5 rounded-full bg-[#F0F0F0] overflow-hidden max-w-[160px]">
          <div
            v-if="!item.insufficientData && item.value !== null"
            class="h-full rounded-full"
            :style="{ width: `${item.value}%`, backgroundColor: barColor(item.severity) }"
          />
        </div>
        <span
          class="text-[12px] font-bold w-8 text-right"
          :style="{ color: item.insufficientData ? 'var(--color-disabled)' : barColor(item.severity) }"
        >
          {{ item.insufficientData ? '—' : item.value }}
        </span>
        <span
          class="text-[11px] w-10 text-right shrink-0"
          :style="{ color: trendColor(item.trendDirection) }"
        >
          {{ trendGlyph(item) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImpactDimensionAnomalyBars',
  props: {
    dimensions: {
      type: Object,
      default: null,
    },
  },
  computed: {
    items() {
      return this.dimensions?.items || [];
    },
    entriesN() {
      return this.dimensions?.entriesN ?? 0;
    },
    periodLabel() {
      return this.dimensions?.periodLabel || '';
    },
    showEmpty() {
      return Boolean(this.dimensions?.insufficientData) || this.items.length === 0;
    },
  },
  methods: {
    dimensionLabel(key) {
      const i18nKey = `UserProjects.impactAnalysis.dimensions.keys.${key}`;
      const translated = this.$t(i18nKey);
      return translated === i18nKey ? key : translated;
    },
    barColor(severity) {
      if (severity === 'green') return '#22C55E';
      if (severity === 'yellow') return '#EAB308';
      if (severity === 'red') return '#EF4444';
      return 'var(--color-disabled)';
    },
    trendGlyph(item) {
      if (item.insufficientData || item.deltaVsPrevious === null) return '';
      if (item.trendDirection === 'up') return `↑${Math.abs(item.deltaVsPrevious)}`;
      if (item.trendDirection === 'down') return `↓${Math.abs(item.deltaVsPrevious)}`;
      return '→0';
    },
    trendColor(direction) {
      if (direction === 'up') return '#22C55E';
      if (direction === 'down') return '#EF4444';
      return 'var(--color-disabled)';
    },
  },
};
</script>
